import { useMutation } from "@tanstack/react-query";
import { Narendra_Modi_Election_API_URL } from "../Process";
import Cookies from "js-cookie";
// export const useMemberListExportExcel = () => {
//   return useMutation({
//     mutationFn: async (filterData) => {
//       const { name, mobileNo, gender, idCardNo, outside, handicap, locality, village } = filterData || {};

//       const outsideValue = outside?.trim()?.toLowerCase() === "true";
//       const handicapValue = handicap?.trim()?.toLowerCase() === "true";

//       const temptItems = {
//         Name: name || "",
//         MobileNo: mobileNo || "",
//         Gender: gender || "",
//         IDCardNo: idCardNo || "",
//         OutSide: outsideValue,
//         Handicap: handicapValue,
//         Address: locality || "",
//         VillageName: village || "",
//         PerPage: "",
//         UniqueID: "",
//       };

//       const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberListData`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(temptItems),
//       });

//       if (!response.ok) {
//         throw new Error("Network response was not ok");
//       }

//       const result = await response.json();
//       console.log("responseresponseresponse", result);
//       return result?.data;
//     },
//   });
// };
export const useMemberListExportExcel = () => {
  return useMutation({
    mutationFn: async (filterData) => {
      const { name, mobileNo, gender, idCardNo, outside, handicap, locality, village, VidhanSabha } = filterData || {};

      const outsideValue = outside?.trim()?.toLowerCase() === "true";
      const handicapValue = handicap?.trim()?.toLowerCase() === "true";

      const temptItems = {
        Name: name || "",
        MobileNo: mobileNo || "",
        Gender: gender || "",
        IDCardNo: idCardNo || "",
        OutSide: outsideValue,
        Handicap: handicapValue,
        Address: locality || "",
        VillageName: village || Cookies.get("Narendra_Modi_Village_ID") || "",
        Vidhansabha: VidhanSabha || "",
        PerPage: "10",
        UniqueID: "",
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberListData_V4`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      console.log("responseresponseresponse", result);
      return result?.data;
    },
  });
};

// export const useVoterMemberListExportExcel = () => {
//   return useMutation({
//     mutationFn: async (filterData) => {
//       const { name, village } = filterData || {};

//       const temptItems = {
//         Name: name || "",
//         PartNameEnglish: village || "",
//         PerPage: "",
//         UniqueID: "",
//       };

//       const response = await fetch(`${Narendra_Modi_Election_API_URL}getVoterYojnaDetail`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(temptItems),
//       });

//       if (!response.ok) {
//         throw new Error("Network response was not ok");
//       }

//       const result = await response.json();
//       console.log("responseresponseresponse", result);
//       return result?.data;
//     },
//   });
// };
export const useVoterMemberListExportExcel = () => {
  return useMutation({
    mutationFn: async (filterData) => {
      const { name, village } = filterData || {};

      const temptItems = {
        Name: name || "",
        PartNameEnglish: village || Cookies.get("Narendra_Modi_Village_ID") || "",
        PerPage: "",
        UniqueID: "",
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getVoterYojnaDetail_V4`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      console.log("responseresponseresponse", result);
      return result?.data;
    },
  });
};
export const useBeneficialMemberDataExportExcel = (Vidhansabha) => {
  return useMutation({
    mutationFn: async (params) => {
      const { GramYojnaID, VillageName, Name, MobileNo } = params || {};
      const temptItems = {
        VillageNameEnglish: VillageName || "",
        GramYojnaID: GramYojnaID || "",
        Vidhansabha: Vidhansabha || "",
        Name: Name || "",
        MobileNo: MobileNo || "",
        PerPage: "",
        UniqueID: "",
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getBeneficialMemberData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      console.log("responseresponseresponse", result);
      return result?.data;
    },
  });
};
export const useGrantDetailsDataExportExcel = () => {
  return useMutation({
    mutationFn: async (params) => {
      const { GrantYojnaName, VillageID, Name } = params || {};
      const temptItems = {
        GrantYojnaName: GrantYojnaName || "",
        VillageID: VillageID || "",
        YojnaName: Name || "",
        PerPage: "",
        UniqueID: "",
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      console.log("responseresponseresponse", result);
      return result?.data;
    },
  });
};

export const useVillageWiseMandaliCountExportData = () => {
  return useMutation({
    mutationFn: async (params) => {
      console.log("sdlfjskldfjskfjaskfjsakfadjsf", params);
      const { bhajanMandaliTypeID } = params || {};
      const temptItems = {
        BhajanMandaliTypeID: bhajanMandaliTypeID,
      };

      // const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageWiseBhajanMandaliCount`, {
      const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageWiseBhajanMandaliCount_V1`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      console.log("responseresponseresponse", result);
      return result?.data;
    },
  });
};

export const useMandaliDetailExportData = () => {
  return useMutation({
    mutationFn: async (params) => {
      console.log("dsfjlksdjfksdf", params);
      const { bhajanMandaliName, villageID, bhajanMandaliTypeID } = params || {};
      console.log("sdfjkldsjfksdafjksdfjasd", bhajanMandaliName);
      const temptItems = {
        BhajanMandaliName: bhajanMandaliName || "",
        BhajanMandaliID: "",
        BhajanMandaliTypeID: bhajanMandaliTypeID || "",
        BhajanMandaliType: "",
        VillageID: villageID || "",
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageWiseBhajanMandaliDetail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      console.log("responseresponseresponse", result);
      return result?.data;
    },
  });
};
// -------------------khushi---------------------------
export const useSakhiMandalMemberDetailExportData = () => {
  return useMutation({
    mutationFn: async (params) => {
      const {
        sakhiMandalName,
        shgName,
        villageName,
        gramPanchayat,
        awc,
        designationInSHG,
        shgCode,
        memberCode,
        memberName,
        mobileNo,
        studentID,
        studentName,
        studentCaste,
        year,
        filterSakhiMandalName,
        type,
      } = params || {};
      const selectedGramPanchayat = villageName || "";
      const filteredGramPanchayat = gramPanchayat || "";
      const filteredSHGName = shgName || filterSakhiMandalName || sakhiMandalName || "";
      const usesDashboardFilters = ["Anganwadi", "Harpati", "YuvaSanghatan"].includes(type);
      const temptItems = {
        SHGMemberID: "",
        Type: type || "SakhiMandal",
        SHGCode: shgCode || "",
        SHGName: usesDashboardFilters ? "" : filteredSHGName,
        SakhiMandalName: usesDashboardFilters ? "" : filteredSHGName,
        MemberCode: memberCode || "",
        MemberName: usesDashboardFilters ? "" : studentName || memberName || "",
        MobileNo: usesDashboardFilters ? "" : mobileNo || "",
        StudentID: studentID || "",
        StudentName: usesDashboardFilters ? "" : studentName || memberName || "",
        StudentCaste: studentCaste || "",
        Year: year || "",
        Village: selectedGramPanchayat,
        GramPanchayat: filteredGramPanchayat,
        AWC: awc || "",
        DesignationInSHG: usesDashboardFilters ? "" : designationInSHG || "",
        IsActive: "true",
        IsDelete: "false",
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getSakhiMandalWiseMemberDetail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      const data = result?.data || [];
      if (!usesDashboardFilters) return data;

      const contains = (value, search) =>
        !search ||
        String(value || "")
          .toLowerCase()
          .includes(String(search).trim().toLowerCase());
      return data.filter(
        (item) =>
          contains(item?.GramPanchayat, filteredGramPanchayat) &&
          contains(item?.AWC, awc) &&
          contains(item?.SHGName, shgName) &&
          contains(item?.MemberName, memberName) &&
          contains(item?.DesignationInSHG, designationInSHG) &&
          contains(item?.MobileNo, mobileNo),
      );
    },
  });
};
